<template>
  <div class="copy-pricacy">
  <div @click="copy" class="copy-btn">
    <span>查看全部版本</span>
    <span>复制</span>
  </div>
  <div v-show="false" id="copyId" style="white-space: pre-wrap;">
    发布日期：2026年02月02日

生效日期：2026年02月09日

版本号：V2

本政策适用于极兔速递有限公司及其子公司、直属分支机构、加盟合作伙伴等（以下简称“极兔”或“我们”）通过官方网站、极兔速递+小程序、微信公众号、兔兔打单VIP等向客户（以下简称“您”）提供寄件地为中国境内的物流服务，我们一直非常重视用户的隐私和个人信息保护，您在使用我们的产品与/或服务时，我们会收集和使用您的相关个人信息。本隐私政策与您所使用的服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，请务必仔细阅读并理解本政策，以便您更好地了解我们的产品及提供的各项服务，并做出适当的选择。我们将会通过本隐私政策向您说明我们在提供产品与/或服务时如何收集、存储、使用、共享、转让、公开披露这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。一旦您开始使用或在我们更新本隐私政策后继续使用我们的产品与/或服务，即表示您已充分理解并同意本政策（含更新版本）内容，并且同意我们按照本政策的约定处理您的个人信息。如您不同意本隐私政策的任何条款，您应立即停止使用我们的产品与/或服务。 如果您对本隐私政策有任何疑问、意见或建议，可通过隐私保护邮箱与我们联系，一般情况下，我们将在十五日内回复。

本政策将帮助您了解以下内容：

1. 我们处理您的个人信息的基本规则

2. 我们如何收集和使用您的个人信息

3. 我们如何使用Cookie和同类技术

4. 我们如何对外提供、转移、公开披露您的个人信息

5. 我们如何保护和保存您的个人信息

6. 您的权利

7. 您的个人信息如何在全球范围转移

8. 第三方SDK功能说明

9. 我们如何处理儿童的信息

10. 本政策如何更新及争议解决

11. 如何联系我们

1. 我们处理您的个人信息的基本规则

1.1个人信息：指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息。如个人电话号码、个人信息主体账号、IP地址、唯一设备识别码等。

敏感个人信息：是指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁的未成年人的个人信息。

本政策中，若个人信息为敏感个人信息的，我们将以字体加粗的形式提示您注意并获取您的单独同意。就我们为您提供的服务而言，我们处理的您的个人信息的范围如下所示：

个人信息类型	个人信息字段
个人基本资料	姓名、地址、个人电话号码、邮箱、生日、性别、地区、学校、学历、入学年份、学制、公司名称
网络身份标识信息	账号名称/昵称、商家ID、IP地址、微信ID、账号对应的新密码与旧密码、网络身份认证凭证
个人通信信息	通信记录和内容、短信记录和内容、验证码
个人财产信息	订单号、交易金额、运单信息（运单号、寄件人及收件人的姓名、地址、联系方式、货件信息和路由记录）、发票信息（发票抬头、纳税人识别号、开户银行和银行账号）、银行卡账号、支付宝账号
个人上网记录	网页浏览记录、操作日志
个人常用设备信息	设备识别码（Android ID、BSSID、IMSI、MAC地址、SSID、SIM序列号、设备序列号、设备IMEI、IDFV、IDFA、ICCID、OAID）、设备型号、系统版本、传感器信息（线性加速度传感器信息、陀螺仪传感器信息）、已安装应用列表、运营商信息、设备名称、运行中的进程、SD卡数据
个人身份信息	身份证信息（身份证号码、身份证影像信息）
个人位置信息	经纬度
剪切板信息	剪切板内容
1.2个人信息处理者：是指在个人信息处理活动中自主决定处理目的、处理方式的组织、个人。

1.3处理：包括对个人信息的收集、存储、使用、加工、传输、提供、公开和删除等。

1.3.1 收集：是指获得个人信息的控制权，可以自主决定对个人信息的处理目的、处理方式的行为，包括由个人信息主体主动向我们提供、通过我们与个人信息主体交互或记录个人信息主体行为等“自动采集”方式，以及我们通过接收其他个人信息和/或搜集公开信息等“间接获取”方式。

1.3.2 使用：我们会在“个人信息的收集和使用”所列的表格中说明我们会将您的个人信息用于何种场景和目的，并列明相应的合法处理理由以供您了解我们需要遵循的相应义务。当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意，或告知您其他合法处理理由。本政策所述“使用”专指我们对数据进行加工处理以实现数据的存储、访问和展示、汇聚融合、统计分析等使用和利用方式。

1.3.3 保存：指将个人信息以电子或非电子形式记录于我们可访问和检索的介质中的行为。出于正常业务所需，我们会将产品所需个人信息根据不同的合法处理理由所需的保存期限内进行保存：

a）基于您的授权同意处理的个人信息将自收集之日起保存至处理目的实现、用户注销/删除账户全部信息或撤回同意且约定的反悔期届满；

b）基于订立或履行您作为一方当事人的合同所必需的个人信息将自收集之日起保存至合同履行完毕且诉讼时效届满；

c）基于履行法定义务所必需的个人信息将自收集之日起保存至法定义务履行完毕且诉讼时效届满。

法律法规、规范性文件及监管规定对上述保存期限存在不同要求的，遵守法律法规、规范性文件及监管规定的要求。此外，我们对基于产品所收集的您的个人信息，原则上将依照最新法律要求保留在中华人民共和国境内服务器。未满足法律法规、规范性文件及监管规定的条件和程序的，我们不会向境外主体提供您的任何个人信息。

在您使用小程序的前台静默期间会获取您的openid、unionid和经纬度信息，确保是您本人在操作账号，以确认您的账号安全和持续确认运行环境的安全。

在您将小程序置于后台期间，我们需要获取您的经纬度信息，确保是您本人在操作账号，以确认您的账号安全和持续确认运行环境的安全。

1.3.4 对外提供：指个人信息处理者向其他另一个人信息处理者提供个人信息，且接收方在个人信息主体被告知的个人信息的类别、处理目的和处理方式下处理个人信息的活动。

1.3.5 委托处理：指个人信息处理者委托受托人处理个人信息，并对受托人的个人信息处理活动进行监督的活动。受托人仅能在受托范围内处理个人信息，未经个人信息处理者同意，受托人不得转委托他人处理个人信息。

1.3.6 匿名化：是指个人信息经过处理无法识别特定自然人且不能复原的过程。

2. 我们如何收集和使用您的个人信息

我们会遵循合法、正当、必要的原则，出于向您提供相关产品和服务的目的向您收集和处理您的个人信息，并以列表形式向您披露（请见下文示例），我们尽可能全面、完整、及时地向您披露您的个人信息的收集和使用情况，若您发现我们的披露存在错误或遗漏，请通过本政策所述的联系方式与我们联系。

2.1 随着产品或服务的迭代、拓展、升级，我们收集和使用的您的个人信息类型将会发生变化，若发生上述情形，我们将通过更新本政策和弹窗、页面等方式向您详细说明，并征求您的同意。我们的业务包括了基本业务功能和扩展业务功能，我们仅会出于下述目的，收集和使用您的个人信息：

2.1.1基本功能：

处理目的	合法处理理由	个人信息类型	敏感个人信息字段
注册账号	履约必要
个人电话号码、短信验证码

注：我们会通过向您的手机号发送验证码的方式核验您的身份完成账号注册

登录	履约必要
商业信息登录：商家ID、个人电话号码、短信验证码

账号密码登录：账号、密码

手机号登录：个人电话号码、短信验证码

找回密码、修改密码	履约必要	个人电话号码、短信验证码、新密码、旧密码
网点查询	履约必要		经纬度
寄递实名制要求	强制性法律要求	姓名、个人电话号码	身份证信息（身份证号码、身份证影像信息）、网络身份认证凭证
履行物流合同	履约必要	姓名、地址、个人电话号码、IP地址、设备识别码、公司名称	身份证信息（身份证号码、身份证照片）、网络身份认证凭证
支付结算	履约必要	邮箱、订单号、发票信息（发票抬头、纳税人识别号、开户银行和银行账号）、电子邮箱、手机号、公司地址	交易金额、银行卡账号、支付宝账号
客服、售后（理赔）、功能反馈	履约必要	账号名称/昵称、姓名、地址、个人电话号码、邮箱、运单号	通信记录和内容、收派件过程录音录像、上传证明截图（交易记录）
保障交易安全	履约必要	姓名、个人电话号码、地址、IP地址、微信ID、操作日志、设备识别码（Android ID、IMEI、IMSI、ICCID、MAC地址、SIM序列号、设备序列号、软件安装列表、IDFV、IDFA）	通信记录和内容、网页浏览记录
2.1.2扩展功能：

处理目的	合法处理理由	个人信息类型	敏感个人信息字段
联合登录	授权同意	个人电话号码
完善账号信息	授权同意	生日、性别、地址、学校、学历、入学年份、年制、账号名称/昵称
完善寄件信息	授权同意	个人基本资料（公司名称）
使用历史运单信息补全、纠正不准确或无法派送的地址等运单信息以完成派送	授权同意	姓名、地址、个人电话号码
代收货款	授权同意	姓名、个人电话号码	银行卡号、身份证信息（身份证号码、身份证影像信息）
识别分析	授权同意	姓名、个人电话号码、地址、账号名称/昵称、订单号、操作日志、设备识别码（Android ID、IMEI、IMSI、ICCID、MAC地址、SIM序列号、设备序列号、软件安装列表、IDFV、IDFA、Openid、unionid）、设备型号、系统版本、传感器信息（线性加速度传感器信息、陀螺仪传感器信息）、已安装应用列表、运营商信息、设备名称	身份证信息（身份证号码、身份证影像信息）、通信记录和内容、网页浏览记录、交易金额
便捷下单	授权同意	剪切板内容
发放优惠券	授权同意	个人电话号码、满足发放优惠券的条件有关的记录
2.1.3设备权限信息的收集和使用

设备权限	对应业务功能	功能场景说明	是否可以关闭
麦克风	便捷下单	语音输入运单信息或与我们的客服机器人进行咨询和互动，在此功能中我们会收集您的录音内容以识别您的寄件需求和客服与售后需求。查询服务点、便捷输入地址	可以，关闭后仅影响对应功能，不影响其他功能
通讯录	便捷下单	方便您在填写运单信息时不再手动输入通讯录中联系人的信息	可以，关闭后仅影响对应功能，不影响其他功能
地理位置	查询服务点；便捷下单；识别优惠活动	获取服务点的准确位置信息并使用导航功能；获取当前位置信息帮助用户输入寄件地址，方便用户填写运单中的地址信息；识别用户所在地区是否有优惠活动	可以，关闭后仅影响对应功能，不影响其他功能
相机/摄像头权限
扫码快递单号；

拍摄快递照片；

拍照身份证照片；发起售后；功能反馈

扫码寄件、扫码查单、扫描识别单号信息提升用户操作速度；拍照上传用于问题件快递的举证；上传寄递物品照片；拍摄身份证照片用于实名验证；拍照用于智能识别、扫码绑定；上传图片用于更换头像、在线客服功能；运单号扫描；上传证明-拍照	可以，关闭后仅影响对应功能，不影响其他功能
存储权限	缓存必要信息	保障小程序和APP运行稳定，承诺仅读取或存储必要的信息；上传图片用于智能识别图片信息、更换头像、实名认证、扫码绑定和“在线客服”功能，保存图片功能；发起售后上传证明；进行功能反馈；	可以，关闭后仅影响对应功能，不影响其他功能
相册	识别、上传照片	识别图片地址、上传寄托物品照片、扫描运单号、上传证明；功能反馈；发起售后；	可以，关闭后仅影响对应功能，不影响其他功能
通知权限	系统通知	相关消息推送	可以，关闭后仅影响对应功能，不影响其他功能
网络权限	核心业务功能	数据上传与查看	可以，关闭后仅影响对应功能，不影响其他功能
电话权限	网络电话	拨打网络电话	可以，关闭后仅影响对应功能，不影响其他功能
蓝牙	连接蓝牙打印机	连接蓝牙打印机，打印面单	可以，关闭后仅影响对应功能，不影响其他功能
剪切板	便捷下单	读取、识别剪切板中的内容，用于智能填写收寄件人、联系电话及地址信息	可以，关闭后仅影响对应功能，不影响其他功能
2.2我们从第三方获得您个人信息的情形

我们会以SDK形式接入第三方个人信息处理者并向其提供您的个人信息，如果您拒绝我们向相应关联方和第三方处理者提供您的相关个人信息的，则将导致您无法使用相应的业务功能，有关我们集成的SDK详情，请查看《第三方信息共享清单》。

2.2.1在您同意本政策后我们会通过小程序授权获取您的手机号码，将小程序与我们的账户绑定，这时您可以通过小程序直接登录并使用我们的服务。同样在获得您授权后还会从小程序方共享您的头像、昵称。

2.2.2在通过第三方渠道下单寄件时，例如电商平台、快递物流服务受理组织等，收寄人姓名、地址、电话和货件等面单信息由该第三方收集并打印在我们提供的空白模板上。相关数据信息（收寄件人姓名、地址、货件信息及脱敏后的电话）根据合同约定及个人信息保护策略，通过API接口传递给我们，以完成对您的收寄件相关服务。

2.2.3如我们从我们的合作伙伴获取您的个人信息，我们将依据与第三方的约定，在符合相关法律和法规规定的前提下，使用您的这些个人信息。

2.2.4我们承诺：

a）我们从第三方间接获取您的个人信息的数量为实现产品业务功能所必需的最少数量。

b）从第三方间接获取您的个人信息时，要求第三方说明个人信息来源，并会对其个人信息来源的合法性进行确认。我们将了解并审慎注意第三方已获得您的个人信息处理的授权同意范围包括使用目的，您是否授权同意转让、共享、公开披露等。我们开展业务所需进行的个人信息处理活动超出该授权同意范围的，将在获取您的个人信息后的合理期限内或处理您的个人信息前，征得您的明示同意。

2.3其他用途

2.3.1小程序不会利用您的个人信息进行个性化推送服务。

2.3.2当我们要将您的个人信息用于本政策未载明的其他用途时，或将基于特定目的收集而来的信息用于其他目的时，会通过在线点击授权或邮件、短信形式事先征求您的明确同意。

2.4征得同意的例外

您充分知悉，在以下情形中，我们收集、使用个人信息无须征得您的授权同意：

2.4.1与国家安全、国防安全有关的；

2.4.2与公共安全、公共卫生、重大公共利益有关的；

2.4.3与犯罪侦查、起诉、审判和判决执行等有关的；

2.4.4出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；

2.4.5所收集的个人信息是个人信息主体自行向社会公众公开的；

2.4.6从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；

2.4.7根据您的要求签订和履行合同所必需的；

2.4.8用于维护所提供的服务的安全稳定运行所必需的，例如发现、处置服务的故障；

2.4.9为合法的新闻报道所必需的；

2.4.10法律法规规定的其他情形。

3. 我们如何使用Cookie和同类技术

3.1 Cookie

为确保网站正常运转，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够存储您的偏好等数据。

我们不会将Cookie用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。有关详情，请参见AboutCookies.org。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。

3.2 Do Not Track（请勿追踪）

很多网络浏览器均设有Do Not Track功能，该功能可向网站发布Do Not Track请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了Do Not Track，那么我们的所有网站都会尊重您的选择。

4. 我们如何对外提供、转移、公开披露您的个人信息

4.1对外提供

4.1.1向授权合作伙伴提供：

仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会向合作伙伴提供您的某些个人信息，以提供更好的客户服务和用户体验。我们只会在经用户同意并进行匿名化处理后，向第三方提供收集的个人信息。我们只会提供服务所必要的个人信息，我们将会按照法律的规定向您披露。我们会与授权合作伙伴依法签署数据处理协议，要求他们按照本政策的要求以及采取其他必要的保密和安全措施来处理个人信息，授权合作伙伴有权在已告知您的处理目的、处理方式和个人信息种类等范围内处理个人信息，授权合作伙伴变更原先的处理目的、处理方式的，应当重新取得您的同意。我们的合作伙伴无权将接收的个人信息用于任何其他用途，除非另行获得您的单独同意。

目前，我们的授权合作伙伴包括以下类型：

供应商、服务提供商和其他合作伙伴。我们将信息发送给在全球范围内支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式或潜在风险、运输、仓储、清关、末端收派、支付便利、提供客户服务、提供数据存储或数据分析服务、提供第三方附加业务功能服务（如语音输入、地图功能）或进行学术研究和调查。

具体信息请见《第三方信息共享清单》。

4.1.2向我们的关联公司提供

您的个人信息可能会向极兔的关联公司提供。我们只会提供必要的最小化个人信息，且受本政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。

我们承诺对您的信息进行严格保密，仅会出于合法、正当、必要、特定、明确的目的共享您的用户信息，并且只会共享提供服务所必要的用户信息，除法律法规及监管部门另有规定外。在共享您的个人信息前，我们会进行个人信息安全影响评估。

同时我们会与上述供应商、服务提供商和其他合作伙伴的个人信息安全防护能力水平提出要求，签署严格的承诺书/保密协议/数据处理协议，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。一旦发现违反协议约定将会采取有效措施甚至终止合作。

鉴于我们的合作方可能会基于业务实际需要而不时更换，我们将及时地在第三方共享信息清单中披露我们对外提供信息的情况。如您在使用过程中希望确认数据接收方的最新情形或对我们使用的第三方服务和供应商有任何疑问，您可通过本政策中提供的联系方式与我们取得联系，我们会及时响应您的请求、解答您的疑惑。

4.2转移

我们不会将您的个人信息转移给任何公司、组织和个人，但以下情况除外：

4.2.1在符合相关法律法规及网信部门规定的条件下，根据您的指示，按照我们提供的转移途径将您的个人信息转移至您指定的接收方；

4.2.2如因我们的有关业务/资产转让、重组、处置（包括资产证券化）、合并、分立、收购或解散、被宣告破产等原因需要转移您的个人信息的，我们将向您告知接收方的名称或者姓名和联系方式，我们会要求该接收方继续接受本隐私权政策规定的约束，否则我们将要求该接收方重新向您获得同意。

4.3公开披露

我们仅会在以下情况下，公开披露您的个人信息：

4.3.1获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；

4.3.2如果我们确定您出现违反法律法规或严重违反极兔相关协议规则的情况，或为保护极兔用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或极兔相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及极兔已对您采取的措施。

4.3.3基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。

5. 我们如何保护和保存您的个人信息

5.1我们如何保护您的个人信息安全

5.1.1我们设立了数据安全管理职能，采取个人信息在物理（门禁隔离、监控系统）、管理（制定信息安全体系制度、将数据分类分级、与员工签订保密协议、开展数据安全和隐私保护培训、定期开展合规自评估）和技术（通过https安全浏览方式确保传输加密、采用加密技术确保数据存储加密、敏感信息内容展示脱敏、匿名化处理、系统访问部署了双因素认证访问控制机制、自动化代码检查、日志审计）等方面的安全保障措施努力保护您的个人信息不被未经授权地访问、使用、披露、修改、损坏或丢失及其他的形式的非法处理。

5.1.2我们会定期组织安全应急预案演练，防止安全事件发生。若不幸发生极兔知悉所获取并储存的数据安全受到危害时，或由于外部行为（例如黑客攻击）使用户的非公开信息被披露给不相关第三方时，尽管本政策中有其他免责规定，极兔也会启动应急预案，组成紧急应急小组，启动流程，进行内部调查、上报并通知监管部门，以及配合监管部门工作，降低事故对用户的影响，同时会在认为适当的情况下采取推送通知、邮件、公告等形式告知相关用户，告知其被披露的信息以及极兔对该等情况的知悉程度。

5.2个人信息的保存期限

5.2.1我们仅会在为达成本指引所述目的所需最短期限内保留个人信息，除非法律有强制的存留要求。

5.2.2如果我们终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理；超出必要期限后，我们也将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。

6. 您的权利

按照中国相关的法律法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：

6.1访问您的个人信息

6.1.1账户信息

如果您希望访问您的账户中的个人资料信息，您可以使用账号和密码或通过第三方授权，登录我们的小程序在“个人设置”中查看绑定的手机号码，通过“我的”或“个人中心”中查看其他信息。

6.1.2账单查询（兔兔打单VIP小程序适用）

您可以使用账号和密码或通过第三方授权，登录我们的小程序在“首页”－“账单查询”中查询。

6.1.3订单信息（极兔速递+小程序适用）

您可以使用账号和密码或通过第三方授权，登录我们的小程序在“查件”中查询所有寄件订单信息。

如您需要访问您在使用我们的产品与/或服务过程中产生的其他个人信息，您可以通过本隐私政策所列明的隐私保护邮箱与我们联系，我们会在十五日内响应您的请求。

6.2更正或补充您的个人信息

当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正或补充。

如您需要更正或补充您在使用我们的产品或服务过程中产生的其他个人信息，您可以与我们的隐私保护邮箱联系，我们会在十五日内响应您的请求。

6.3删除您的个人信息

6.3.1您可以在以下情形中，向我们提出删除个人信息的请求：

a）如果我们处理个人信息的行为违反法律法规；

b）如果我们收集、使用您的个人信息，却未征得您的同意；

c）如果我们处理个人信息的行为违反了与您的约定；

d）如果您不再使用我们的产品与/或服务，或您注销了账号；

e）如果我们不再为您提供产品与/或服务。

您可以通过本政策披露的隐私保护邮箱与我们联系向我们提出删除个人信息的申请（适用于极兔速递+小程序），或通过注销账户（联系客编所在网点进行关闭客编操作）的方式删除您的个人信息（适用于极兔客户管家小程序）。在满足法律法规的要求的前提下，我们将在十五日内响应您的请求，对个人信息进行完全删除。

6.3.2当您或我们协助您从我们的服务中删除信息后，因为适用的法律和安全技术，我们可能无法立即备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。

6.3.3若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，并要求其及时删除（除非法律法规另有规定，或这些主体已独立获得您的授权）。

6.4获取个人信息副本

如您需要您的个人信息副本，您可以通过隐私保护邮箱我们联系，向我们提出相应请求，我们会在十五日内响应您的请求。在通过必要的验证措施后，我们将在法律法规允许的情况下，按照本政策所列明的方式和期限处理您的请求并将您的个人信息发送您至指定的邮箱。

6.5改变您授权同意的范围

每个业务功能需要一些基本的个人信息才能得以完成（见本政策第一部分）。对于其他（见本政策“（二）扩展业务功能收集和使用您个人信息的情形”）个人信息的收集和使用，您可以随时给予或收回您的授权同意。您可以通过关闭系统权限或通过隐私保护邮箱联系我们的方式来撤回您原来的授权，我们会在十五日内响应您的请求。但请您注意，此项撤回不影响我们之前通过您的授权所收集的个人信息，同时，因您的某些授权是实现我们某些业务功能的必要权限，您撤回相应授权的可能会影响您使用我们对应的部分业务功能。

另外您也可以通过注销账号的方式，撤回我们继续收集您个人信息的全部授权。

6.5.1当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。

6.5.2当您收到我们发送的短信时，可以根据信息中的退订提示（如“回复TD退订”），要求不再向您发送短信，我们会尊重您的请求。您可以通过隐私保护邮箱向我们提出相应请求，在通过必要的验证措施后，我们将本政策所列明的方式和期限处理您的请求。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。

当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。

6.6个人信息主体注销账户

您可以通过登录小程序，根据“我的”－“注销账号”路径（适用于极兔速递+小程序），或联系客编所在网点进行关闭客编操作的方式（适用于极兔客户管家小程序）提交注销账户的请求。我们会提供注销协议，告知您执行注销操作可能造成的影响，当您继续选择注销我们的账户时，我们将在十五日内响应您的需求，根据法律法规删除或匿名化处理。

您可以通过向本政策中提到的隐私保护邮箱提交注销账户的请求。我们会提供注销协议，告知您执行注销操作可能造成的影响，当您继续选择注销我们的账户时，我们将在十五日内响应您的需求，根据法律法规删除或匿名化处理（适用于极兔速递+小程序以外渠道）。

6.7逝者的个人信息保护

我们会持续确保用户的信息安全。自然人用户去世后，其近亲属（以下简称“逝者近亲属”）为了自身的合法、正当利益，可以通过本政策所述的联系方式，与我们取得联系。

为了充分保护逝者的个人信息权益，申请行使该等权利的逝者近亲属需要根据极兔的指定流程，提交逝者的身份证明文件、死亡证明文件、以及逝者近亲属本人的身份证明、与逝者之间的亲属关系证明等证明文件，并提供申请行使的权利种类及目的。完成身份核验手续后，对逝者的相关个人信息行使冻结、删除等权利，但是逝者生前另有安排的除外。

6.8响应您的上述请求

6.8.1为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。

6.8.2您的请求我们将在十五日内作出答复。如您对我们的答复不满意，还可以通过本政策所述的联系方式向我们投诉。

6.8.3对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。

6.8.4在以下情形中，按照法律法规要求，我们将无法响应您的请求：

a）与个人信息处理者履行法律法规规定的义务相关的；

b）与国家安全、国防安全直接相关的；

c）与公共安全、公共卫生、重大公共利益直接相关的；

d）与刑事侦查、起诉、审判和执行判决等直接相关的；

e）个人信息处理者有充分证据表明个人信息主体存在主观恶意或滥用权利的；

f）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；

g）响应您的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；

h）涉及商业秘密的。

7. 您的个人信息如何在全球范围转移

原则上，我们在中华人民共和国境内运营中收集和产生的个人信息，将存储在中华人民共和国境内。

如您选择我们的国际件服务，我们会通过将国际件运单信息传输给您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。此外，为实现本政策所声明的其他目的，您的个人信息亦可能被传输到您使用产品或服务所在国家/地区的境外管辖区。

此类管辖区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在原始收集国/地区境内足够同等的保护。例如，运单信息采取加密传输、定期评估审计接收方的安全能力水平、签订数据处理协议/条款。

8. 第三方SDK功能说明

合作的第三方SDK服务商：当您使用极兔由第三方提供的功能时，我们可能会接入由第三方提供的软件开发包（ SDK ）以实现相关功能。此时，第三方SDK服务商可能会收集您相关的个人信息。前述服务商收集和处理信息等行为遵守其自身的隐私条款，而不适用于本政策。为了最大程度保障您的信息安全，我们建议您在使用任何第三方SDK类服务前先行查看其隐私条款。为保障您的合法权益，如您发现此等SDK或其他类似的应用程序存在风险时，建议您立即终止相关操作并及时与我们取得联系。

具体请查阅：《第三方信息共享》

9. 我们如何处理儿童的个人信息

9.1我们非常重视对儿童个人信息的保护。若您是未满十四周岁未成年人（下称“儿童”）14周岁以下的儿童，在使用我们的产品或服务前，应在您监护人监护、指导下共同阅读本隐私政策以及我们制定的专门规则 《儿童个人信息保护规则》及《儿童用户协议》并征得您的监护人的同意。

9.2我们不会主动直接向儿童收集个人信息。对于经监护人同意而收集儿童个人信息的情况，我们只会在受到法律允许、监护人同意或者保护儿童所必要的情况下使用、共享、转让或披露此信息。

9.3如有事实证明儿童并未取得监护人同意的情况下注册使用了我们的产品或服务，我们会与监护人协商，并设法尽快删除相关个人信息。如果我们发现在未事先获得可证实的监护人同意的情况下收集了儿童的个人信息，则会设法尽快删除相关信息。

9.4对于可能涉及的不满14周岁的儿童个人信息，我们进一步采取以下措施予以保障：

9.4.1对于收集到的儿童个人信息，我们除遵守本隐私政策关于用户个人信息的约定外，还会秉持正当必要、知情同意、目的明确、安全保障、依法利用的原则，严格遵循《儿童个人信息网络保护规定》等法律法规的要求进行存储、使用、披露，且不会超过实现收集、使用目的所必须的期限，到期后我们会对儿童个人信息进行删除或匿名化处理。

9.4.2当您作为监护人为被监护的儿童选择使用极兔产品或服务时，我们可能需要向您收集被监护的儿童个人信息，用于向您履行相关服务之必要。在具体服务中需要向您收集儿童个人信息的，我们会事先取得您的授权同意，并告知您收集的目的和用途。如果您不提供前述信息，您将无法享受我们提供的相关服务。若儿童本人需要注册或使用我们的产品与/或服务，您应正确引导并予以监护。

9.4.3儿童或其监护人有权随时访问和更正儿童个人信息，还可以通过隐私保护邮箱向我们提出更正和删除的请求。如您对儿童个人信息相关事宜有任何意见、建议或投诉、举报，请通过本隐私政策公示的联系方式与我们联系联系我们。我们会随时为您提供帮助。

10. 本政策如何更新及争议解决

10.1未经您明确同意，我们不会削减您按照本政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。

10.2对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过弹窗发送通知，说明隐私政策的具体变更内容）。

10.3本政策所指的重大变更包括但不限于：

10.3.1我们的服务模式发生重大变化。如处理个人信息的目的、处理个人信息的类型以及个人信息的使用方式等；

10.3.2我们在控制权、组织架构等方面发生重大变化。如并购重组等引起的控制者变更等；

10.3.3个人信息共享、转让或公开披露的主要对象发生变化；

10.3.4您参与个人信息处理方面的权利及其行使方式发生重大变化；

10.3.5我们负责处理用户信息安全的责任部门、联络方式及投诉渠道发生变化时；

10.3.6用户信息安全影响评估报告表明存在高风险时。

10.4本政策的执行、解释及争议的解决均适用中华人民共和国法律，且不考虑任何冲突法。

10.5您和我们就本政策内容或其执行发生任何争议的，双方应友好协商解决；如双方无法协商解决争议时，您可以向公安、监管部门（网信办等）或权威部门投诉、举报，或者依据适用的法律向具有管辖权的法院提起诉讼。

11. 如何联系我们

11.1我们设置了专门的信息安全部门保护您的个人信息，如有相关问题可通过下列方式反馈或投诉举报。我们将在十五日向您反馈。

个人信息保护负责人：王先生

隐私保护邮箱：privacy@jtexpress.com

或者寄信到上海市青浦区华新镇华隆路1777号A座9楼 信息安全部门（收）邮编：201705。

11.2我们的信息

我们的地址：上海市青浦区华新镇华隆路1777号；

官方网站地址：https://www.jtexpress.com；

邮件：jtservice@jtexpress.com；

客服电话：956025

个人信息收集
极兔将尽全力保护您的个人信息安全，并保障您在个人信息处理过程中的相关权益。为了向您提供极兔的业务服务，我们需要收集您在使用该服务时主动提供/授权等方式产生的个人信息，详情可查阅下文：

个人基本资料

网络身份标识信息

个人财产信息

个人上网记录

个人常用设备信息

个人身份信息

个人位置信息

企业信息

剪贴板信息

个人基本资料

1. 姓名

使用目的	实名认证：履行物流合同；运单信息补全纠正；客服与售后；代收货款；保障交易安全、识别分析
使用场景	提交订单、生成物流运单、收件、分拣，以及派送货件时
2. 地址

使用目的	履行物流合同；客服与售后；保障交易安全
使用场景	提交订单、生成物流运单、收件、分拣，以及派送货件时
3. 个人电话号码

使用目的	注册账号；登录；履行物流合同；代收货款；客服与售后；保障交易安全；识别分析；推荐及广告消息推送
使用场景	找回密码、提交订单、生成物流运单、收件、分拣，以及派送货件时
4. 性别

使用目的	完善账号信息
使用场景	用户补充账号信息时
5. 公司名称

使用目的	补充下单信息
使用场景	用户补充下单信息时
6. 邮箱

使用目的	完善个人信息
使用场景	用户完善个人信息时
7. 生日

使用目的	完善账号信息
使用场景	用户补充账号信息时
8. 地区

使用目的	完善账号信息
使用场景	用户补充账号信息时
9. 学校、学历、入学年份、年制

使用目的	完善账号信息
使用场景	用户补充账号信息时
网络身份标识信息

1. 账号名称/昵称/商家ID

使用目的	完善账号信息；客服与售后；识别分析；登录
使用场景	用户补充账号信息时；用户与客服人员沟通进行身份核验时；改善产品或服务时；选择参与极兔的促销活动，享受订单金额减免、领取赠品时；
2. IP地址

使用目的	保障交易安全、履行物流合同
使用场景	判断交易风险时
3. 微信ID

使用目的	联合登录；保障交易安全
使用场景	用户从微信端使用极兔服务时：判断交易风险时；选择参与极兔的促销活动，享受订单金额减免、领取赠品时；
4. 账号对应的新密码与旧密码

使用目的	注册账号、用户登录、找回密码、修改密码
使用场景	用户注册账号时；用户账号密码登录账号时；用户修改密码、找回密码时；
5. 网络身份认证凭证

使用目的	用户实名认证、履行物流合同
使用场景	用户实名认证时；履行物流合同时。
个人通信信息

1. 通信记录和内容

使用目的	客服与售后；保障交易安全；识别分析
使用场景	用户与客服人员沟通时；判断交易风险时；改善产品或服务时
2. 短信记录和内容

使用目的	修改密码；保障交易安全；识别分析
使用场景	判断交易风险时；改善产品或服务时
3. 验证码

使用目的	修改密码；
使用场景	用户修改密码时
个人财产信息

1. 订单号

使用目的	支付结算；识别分析
使用场景	用户使用支付服务时；改善产品或服务时
2. 交易金额

使用目的	支付结算；识别分析
使用场景	用户使用支付服务时；改善产品或服务时
3. 运单信息（运单号、寄件人及收件人的姓名、地址、联系方式、货件信息和路由记录）

使用目的	履行物流合同；运单信息补全纠正；客服与售后；保障交易安全；识别分析
使用场景	提交订单、生成物流运单、收件、分拣、仓储、运输、出口清关、进口清关，以及派送货件时；用户与客服人员进行沟通时；判断交易风险时；改善产品或服务时
4. 发票信息（发票抬头、纳税人识别号、开户银行和银行账号）

使用目的	支付结算
使用场景	用户申请开具发票时
5. 银行卡号

使用目的	支付结算
使用场景	使用代收货款服务时
6. 支付宝账号

使用目的	支付结算
使用场景	使用代收货款服务时
个人上网记录

1. 网页浏览记录

使用目的	保障交易安全；识别分析；
使用场景	判断用户账号风险时；改善产品或服务时
2. 操作日志

使用目的	保障交易安全；识别分析
使用场景	判断用户账号风险时；改善产品或服务时
个人常用设备信息

1. 设备识别码

使用目的	保障交易安全：服务消息推送；识别分析；推荐及广告消息推送
使用场景	判断交易风险时；向用户推送快件路由信息、支付状态信息及优惠券、促销信息时：改善产品或服务时；向用户推送广告消息时；为提高您使用我们的服务时系统的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更准确地预防钓鱼网站欺诈和保护账户安全时；用户登录，同意隐私政策
2. 设备型号

使用目的	识别分析
使用场景	改善产品或服务时
3. 系统版本

使用目的	识别分析
使用场景	改善产品或服务时
4. 传感器信息（线性加速度传感器信息、陀螺仪传感器信息）

使用目的	识别分析
使用场景	改善产品或服务时
5. 已安装应用列表

使用目的	识别分析
使用场景	改善产品或服务时
6. 运营商信息

使用目的	识别分析
使用场景	改善产品或服务时
7. 设备名称

使用目的	识别分析
使用场景	改善产品或服务时
8. 运行中的进程

使用目的	识别分析
使用场景	改善产品或服务时
9. SD卡数据

使用目的	识别分析
使用场景	改善产品或服务时
个人身份信息

1. 身份证信息（身份证号码、身份证影像信息）

使用目的	实名认证；识别分析；履行物流合同；代收货款
使用场景	用户首次实名认证时；改善产品或服务时；快件清关时；使用代收货款服务时
个人位置信息

1. 经纬度

使用目的	提供地图服务；识别分析
使用场景	用户查询服务点时；用户下单便捷输入地址时
企业信息

1. 营业执照

使用目的	企业账户首次认证
使用场景	企业账户首次认证时
2. 组织机构代码证

使用目的	企业账户首次认证
使用场景	企业账户首次认证时
3. 税务登记证

使用目的	企业账户首次认证
使用场景	企业账户首次认证时
剪贴板信息

1. 剪贴板内容

使用目的	便捷下单
使用场景	用户下单时
第三方信息共享
一、第三方SDK列表

当您使用极兔由第三方提供的功能时，我们可能会接入由第三方提供的软件开发包（SDK）以实现相关功能。此时，第三方SDK服务商可能会收集您相关的个人信息。前述服务商收集和处理信息的行为遵守其自身的隐私政策，而不适用于极兔速递的用户隐私政策。为了最大程度保障您的信息安全，我们建议您在使用任何第三方SDK类服务前先行查看其隐私政策。为了保护您的合法权益，如您发现此等SDK或其他类似的应用程序存在风险时，建议您立即终止相关操作并及时与我们取得联系。

SDK名称：友盟统计分析SDK

SDK主体：友盟同欣（北京）科技有限公司

使用信息：设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息

信息使用目的：运营统计与分析

信息使用场景：运营统计与分析时

信息传输方式：初始化SDK后，App基础数据上报

第三方隐私政策：https://www.umeng.com/page/policy

SDK名称：友盟推送SDK

SDK主体：友盟同欣（北京）科技有限公司

使用信息：设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、网络信息、位置信息、应用列表

信息使用目的：消息推送

信息使用场景：推送消息时

信息传输方式：初始化SDK后，App基础数据上报

第三方隐私政策：https://www.umeng.com/page/policy

SDK名称：腾讯云SDK

SDK主体：腾讯云

使用信息：身份证信息

信息使用目的：实名验证

信息使用场景：图片识别

信息传输方式：/

第三方隐私政策：https://cloud.tencent.com/document/product/301/11470

SDK名称：百度智能云SDK

SDK主体：百度智能云

使用信息：地理位置信息

信息使用目的：填写地址

信息使用场景：图片识别

信息传输方式：/

第三方隐私政策：https://cloud.baidu.com/doc/Agreements/s/Plr0fi68q

SDK名称：高德地图/高德地图服务端（restapi.amap.com）

SDK主体：高德地图

使用信息：地理位置信息、经纬度信息

信息使用目的：填写地址

信息使用场景：查看订单详情，编辑寄件/收件地址，需要获取您的地理位置信息。

信息传输方式：初始化SDK后，App基础数据上报

第三方隐私政策：https://lbs.amap.com/pages/privacy

二、第三方共享个人信息列表

为向您提供物流服务、消息推送等功能，您的个人信息可能与以下第三方进行共享，具体共享情况说明如下：

产品/类型：支付结算及消息推送

第三方公司名称：第三方支付服务供应商（如支付宝）

传输信息：订单号、订单信息（运单号、运单状态、物流轨迹）、收件人手机号

使用目的：为用户提供订单消息推送及订单支付

使用场景：使用支付功能或订单消息推送时

信息传输方式：后台接口传输

第三方隐私政策：https://render.alipay.com/p/c/180020570000000579/index.html

产品/类型：用户快递柜寄件服务

第三方公司名称：深圳市丰巢科技有限公司

传输信息：位置信息（经纬度）、收件人信息（地址、姓名、联系方式）、寄件人信息（地址、姓名、联系方式）、快件类型、物品数量、声明价值、物品类型、物品重量、付款方式、下单人手机号码、寄件人身份信息（证件类型、身份证姓名、身份证号码）、发票信息（发票抬头、纳税人识别号、开户银行和银行账号）

使用目的：为用户提供快递柜寄件的附近快递柜信息查询、提交订单、开具发票

使用场景：用户使用快递柜寄件时

信息传输方式：后台接口传输

第三方隐私政策：https://edms.fcbox.com/staticResource/wechat/play.html?script=op-commonPage-play&code=ZHJ2ZRZQRQ3GA81SXKBT8K2F34
  </div>
  </div>
</template>

<script>
export default {
  methods: {
    copy() {
      let content = document.getElementById('copyId').innerText
      content = typeof content === 'string' ? content : content.toString() // 复制内容，必须字符串，数字需要转换为字符串
      if (!document.queryCommandSupported('copy')) {
        // 为了兼容有些浏览器 queryCommandSupported 的判断
        // 不支持
        this.toast('fail', '您的浏览器不支持该快捷功能，请长按复制')
        return
      }
      const textarea = document.createElement('textarea')
      textarea.value = content
      textarea.readOnly = 'readOnly'
      document.body.appendChild(textarea)
      textarea.select() // 选择对象
      textarea.setSelectionRange(0, content.length) // 核心
      const result = document.execCommand('copy') // 执行浏览器复制命令
      if (result) {
        this.toast('success', '已复制全文')
      } else {
        this.toast('fail', '您的浏览器不支持该快捷功能，请长按复制')
      }
      textarea.remove()
    },
    toast(type, msg) {
      this.$toast({
        type,
        message: msg,
        duration: 2000,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.copy-btn {
  width: 100%;
  height: 36px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fffce6;

  span:nth-child(2) {
    cursor: pointer;
  }
}
</style>
